import React, { useEffect } from "react";
import Button from "./atoms/ActionButton";

const CookieModal = ({ setCookieModal, onOpenSettings }) => {
  // Bloqueo de scroll robusto (funciona también en iOS/táctil, donde
  // overflow:hidden se ignora). Fija el body y restaura la posición al cerrar.
  useEffect(() => {
    const scrollY = window.scrollY;
    const body = document.body;
    const prev = {
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
      overflow: body.style.overflow,
    };
    body.style.position = "fixed";
    body.style.top = `-${scrollY}px`;
    body.style.left = "0";
    body.style.right = "0";
    body.style.width = "100%";
    body.style.overflow = "hidden";
    return () => {
      body.style.position = prev.position;
      body.style.top = prev.top;
      body.style.left = prev.left;
      body.style.right = prev.right;
      body.style.width = prev.width;
      body.style.overflow = prev.overflow;
      window.scrollTo(0, scrollY);
    };
  }, []);

  return (
    <div className="bg-blur">
      <div className="relative bg-[#fffef2] text-phys-ink px-[35px] w-[98%] absolute bottom-0 lg:static lg:max-w-[395px] lg:w-[395px] flex flex-col items-start justify-center gap-3">
        <button
          type="button"
          onClick={setCookieModal}
          className="absolute top-3 right-4 text-phys-ink hover:opacity-60 transition-opacity"
          aria-label="Cerrar"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        <h2 className="mt-[32px] text-[24px] leading-snug">
          Aviso sobre la privacidad
        </h2>
        <p className="leading-5 text-[14px]">
         Al seleccionar «Aceptar todas las cookies», aceptas que se almacenen cookies en tu dispositivo para mejorar la navegación por el sitio web, analizar su uso y contribuir a nuestras iniciativas de marketing.
          <button type="button" onClick={() => { setCookieModal(); window.location.href = '/policies?section=cookies'; }} className="ml-[5px] border-b-[1px] border-black hover:border-0 cursor-pointer">
            Ver política de cookies
          </button>
        </p>
        <div className="flex flex-col gap-3 items-center justify-center w-full py-[15px] pb-[39px]">
          <Button
            label="Aceptar todas las cookies"
            className="h-[60px] w-[335px] font-semibold"
            onClick={setCookieModal}
          />
          <Button
            label="Rechazar todas"
            className="h-[60px] w-[335px] font-semibold"
            onClick={setCookieModal}
          />
          <Button
            label="Configuración de cookies"
            className="h-[60px] w-[335px] font-semibold"
            onClick={onOpenSettings || setCookieModal}
          />
        </div>
      </div>
    </div>
  );
};

export default CookieModal;
